<template>
  <p v-html="highlighted"></p>
</template>

<script>
export default {
  props: ['transcript', 'variables'],
  computed: {
    highlighted() {
      let highlighted = this.transcript
      for (let variable of this.variables) {
        let re = new RegExp(variable, 'i')
        highlighted = highlighted.replace(re, `<span class='badge bg-primary text-white'>${variable}</span>`)
      }

      return highlighted
    }
  }
};
</script>

<style scoped>

</style>
